export const tsmtPartner = {
  seo: {
    title: "TSMT® × Bespire — Partner program for TSMT® therapists",
    description:
      "Official TSMT® × Bespire partnership. LTSZ integration, −40% in year 1 and −20% in year 2 on every plan. One AI assistant for booking, website, invoicing and marketing.",
  },
  hero: {
    badge: "TSMT® × Bespire — official partner",
    title: "Bespire for TSMT® therapists — at a partner price",
    subtitle:
      "A full AI assistant tailored to TSMT® therapists: your own website, online booking, invoicing and marketing in one place — with LTSZ integration and a partner discount.",
    ctaPrimary: "Apply with registration number",
    ctaSecondary: "Free trial",
    imageAlt: "TSMT® therapist working with a child",
    stats: [
      { value: "−40%", label: "Year 1 discount" },
      { value: "−20%", label: "Year 2 discount" },
      { value: "LTSZ", label: "auto sync" },
    ],
  },
  whatIs: {
    heading: "What is Bespire?",
    description:
      "One AI assistant that takes admin off your shoulders — so you can focus on the therapy work.",
    tiles: [
      {
        title: "Your website + online booking",
        description:
          "Your clients book on your own website (built with Bespire in 10 minutes) — no separate app, no install required.",
      },
      {
        title: "Marketing automation",
        description:
          "AI helps with Facebook, Instagram and TikTok posts, ads and a weekly content plan — no separate marketer needed.",
      },
      {
        title: "Client & revenue admin",
        description:
          "Passes, packages, számlázz.hu integration, online card payments — all in one place.",
      },
    ],
  },
  partnership: {
    heading: "The TSMT® × Bespire partnership",
    description:
      "An official strategic partnership with TSMT®. The goal is simple: less admin, a more effective online presence — at a better price for official TSMT® therapists.",
    eligibilityLabel: "Who is eligible",
    eligibility:
      "Every therapist with a valid TSMT® registration number — for both monthly and annual billing.",
  },
  ltsz: {
    badge: "Built‑in integration",
    title: "Connected to LTSZ",
    description:
      "The Bespire AI assistant is integrated with LTSZ. Appointments booked on your website automatically show up in LTSZ too — no double admin.",
    highlight: "Enter it once, see it in both places.",
    steps: [
      {
        title: "1. Booking on your own website",
        description:
          "The client books an appointment on your Bespire‑built website.",
      },
      {
        title: "2. Automatic sync",
        description:
          "The appointment moves to LTSZ in the background — with zero clicks.",
      },
      {
        title: "3. Everything in place",
        description:
          "It appears in LTSZ exactly as it should — no manual entry.",
      },
    ],
    imageAlt: "LTSZ appointment list — bookings from your website appear automatically",
  },
  discount: {
    heading: "TSMT® partner discount",
    subheading: "Only for therapists with a valid registration number.",
    year1Label: "Year 1",
    year1Value: "−40%",
    year2Label: "Year 2",
    year2Value: "−20%",
    note: "Net prices, + VAT. The regular −20% annual discount can be combined. The discount is verified based on your TSMT® registration number.",
    cta: "Apply with registration number",
  },
  packages: {
    eyebrow: "Plans at TSMT® price",
    heading: "Pick the plan that fits you",
    subheading:
      "Monthly or annual — the TSMT® partner discount applies on top. Net prices, + VAT.",
    trialNote: "3‑day free trial · AI assistant included during the trial · No card required",
    recommended: "Recommended",
    ctaPrimary: "Start free trial",
    ctaSecondary: "Request callback",
    perMonth: "/ mo",
    priceSuffix: " HUF + VAT",
    basePriceLabel: "List price",
    tsmtBadge: "TSMT® partner discount",
    year1Label: "Year 1 (−40%)",
    year2Label: "Year 2 (−20%)",
    annualSavingLabel: "Discount per year",
    savingLabel: "You save",
    perMonthShort: "/ mo",
    perYearShort: "/ yr",
    billingToggle: {
      monthly: "Monthly",
      annual: "Annual",
      saveBadge: "−20%",
      annualHint: "Annual billing gets −20% on the list price, on top of the TSMT® partner discount.",
    },
    items: [
      {
        name: "Standard",
        credits: "AI assistant for daily work — included in your plan",
        features: [
          "Your website + online booking",
          "Automatic LTSZ sync",
          "Invoicing and card payments",
          "AI marketing assistant",
        ],
        monthly: {
          base: "13,900 HUF + VAT",
          year1: "8,340 HUF + VAT",
          year2: "11,120 HUF + VAT",
          year1SavingPerMonth: "5,560 HUF + VAT",
        },
        annual: {
          base: "11,120 HUF + VAT",
          year1: "6,672 HUF + VAT",
          year2: "8,896 HUF + VAT",
          year1Saving: "53,376 HUF + VAT",
          year2Saving: "26,688 HUF + VAT",
          perYearLabel: "List annual: 133,440 HUF + VAT",
        },
      },
      {
        name: "Pro",
        credits: "AI assistant for daily work — included in your plan",
        features: [
          "Everything in Growth — optimized for intensive therapy work",
          "Multiple users and locations — smooth operation at higher volume",
          "Priority AI and marketing support — faster response for intensive use",
          "Priority customer support — priority help for your daily work",
        ],
        monthly: {
          base: "24,900 HUF + VAT",
          year1: "14,940 HUF + VAT",
          year2: "19,920 HUF + VAT",
          year1SavingPerMonth: "9,960 HUF + VAT",
        },
        annual: {
          base: "19,920 HUF + VAT",
          year1: "11,952 HUF + VAT",
          year2: "15,936 HUF + VAT",
          year1Saving: "95,616 HUF + VAT",
          year2Saving: "47,808 HUF + VAT",
          perYearLabel: "List annual: 239,040 HUF + VAT",
        },
      },
    ],
  },
  aiCredits: {
    badge: "AI assistant included",
    title: "AI assistant for your daily work — included in your plan",
    subtitle:
      "The AI assistant and every AI generation (text, image, website) are for your daily work — included in your plan. No separate AI charge, no counting.",
    whatIsTitle: "What does included mean?",
    whatIsDescription:
      "Your plan fee covers the AI assistant and AI generation for normal daily business use. During campaign seasons, heavier usage or extreme automated use, extra capacity may be needed.",
    examplesTitle: "How you'll use it day to day",
    examples: [
      {
        task: "Generate a social post",
        credits: "Daily task",
        description: "One Instagram or Facebook post with text and image for your TSMT® exercises.",
      },
      {
        task: "Write website copy",
        credits: "Regular",
        description: "Service description, about page or new page copy for your site.",
      },
      {
        task: "Create a marketing image",
        credits: "During campaigns",
        description: "Unique illustration for a post, pass or workshop ad.",
      },
    ],
    chatFree: {
      title: "AI assistant and AI generation — included in your plan",
      description:
        "Chat with the AI about marketing ideas, co-write copy, generate posts, images or websites — all included in your plan, for your daily work.",
    },
    chatFreeExamples: [
      "Marketing ideas and campaign plans",
      "Copy polishing and rewrites",
      "Questions about the AI assistant and setup help",
    ],
    monthlyIncluded: {
      title: "What's included in both plans",
      standard: "Growth: AI assistant for daily work",
      pro: "Premium: AI assistant + more users, priority support",
      overflow:
        "No separate AI charge, no counting — use it within your plan, whenever and however you need.",
    },
    creditsRollover: {
      title: "",
      description: "",
    },
    freeBadge: "3-day free trial",
    freeNote:
      "After signing up you get 3 days of full access to the AI assistant and every feature — no credit card required.",
    packagesTitle: "",
    packagesIntro: "",
    oneTimeNote: "",
  },
  benefits: {
    heading: "Why it's worth it as a TSMT® therapist",
    items: [
      {
        title: "Your own website",
        description:
          "A professional website with online booking — no separate site builder, no install required.",
      },
      {
        title: "Sessions and passes made simple",
        description:
          "Pre‑bookings for gymnastics and movement classes, automatic pass and package handling.",
      },
      {
        title: "Home exercises delivered",
        description:
          "Assign home exercises to parents in one click — they always find them in their client portal.",
      },
      {
        title: "Invoicing and card payments",
        description:
          "Számlázz.hu integration and online card payments — paperwork automated.",
      },
      {
        title: "GDPR + EU servers",
        description:
          "Your data is stored on EU servers, never used for AI training, and never sold.",
      },
    ],
  },
  replaces: {
    heading: "What does Bespire replace?",
    description:
      "Instead of a separate calendar, messenger, website, newsletter tool and manual LTSZ entry — one AI assistant.",
    leftLabel: "Without separate tools",
    rightLabel: "With Bespire",
    unified: "One system — every function included",
    aiBonus: "AI assistant — helps you become a more successful therapist",
    rightItems: [
      "Calendar + online booking in one",
      "Own website and domain",
      "Automated LTSZ integration",
      "AI marketing assistant",
      "Built-in messaging and newsletters",
    ],
    items: [
      "Separate calendar / booking app",
      "Website provider and domain management",
      "Manual LTSZ entry",
      "Separate marketing / social media tools",
      "Separate newsletter tool",
    ],
  },
  continuousSupport: {
    eyebrow: "Support",
    heading: "You are not left alone with the AI assistant",
    description:
      "We regularly run dedicated workshops for TSMT® therapists where we help you use the AI assistant, answer your questions and let therapists share ideas with each other.",
    webinarLink: "/tsmt-webinar",
    webinarLabel: "Sign up for online workshop",
    items: [
      {
        title: "Dedicated TSMT® workshops",
        description:
          "Regular events just for TSMT® therapists — where you explore every feature of the AI assistant together.",
      },
      {
        title: "Live Q&A",
        description:
          "We answer your questions on the spot — whether it is about booking, LTSZ sync or marketing.",
      },
      {
        title: "Hands-on AI assistant training",
        description:
          "Concrete tips, tricks and settings for your daily therapy work — not just theory, but practice.",
      },
      {
        title: "Peer idea sharing",
        description:
          "Exchange experience from therapist to therapist — how you use Bespire in your own practice.",
      },
    ],
  },
  howToStart: {
    heading: "How do you start?",
    subheading:
      "Two options — either way, the partner discount is live from your very first month.",
    paths: [
      {
        badge: "On your own",
        title: "Start with a 3-day free trial",
        duration: "≈ 10 min",
        description:
          "Sign up and try the AI assistant free for 3 days with full access — or join an online workshop. You only provide your TSMT® registration number at the end to activate the partner discount.",
        steps: [
          "Sign up on Bespire",
          "3 days of full access — try it instantly",
          "Join an online workshop or set it up yourself",
          "Provide your TSMT® registration number at the end for the discount",
        ],
        cta: "Start free trial",
        ctaHref: "/onboarding",
      },
      {
        badge: "With us",
        title: "We set it up for you",
        duration: "≈ 1 business day",
        description:
          "We call you back, align on the details and put your AI assistant together — a one-time 50,000 HUF + VAT setup fee. You just start using it.",
        steps: [
          "Request a callback",
          "We align on your needs on the phone",
          "We build the website, calendar and LTSZ sync",
          "You get it turnkey — bring on your first client",
        ],
        cta: "Request callback",
        ctaHref: "/smb-pricing#callback",
      },
    ],
  },
  video: {
    heading: "\"Finally, an AI assistant that actually helps.\"",
    description:
      "Watch Cili Gonda‑Geszler's take on Bespire — why she started using it and what changed for her.",
  },
  faq: {
    heading: "Frequently asked questions from TSMT® therapists",
    items: [
      {
        q: "How do you verify the TSMT® registration number?",
        a: "You provide the registration number on the application form. We have a short call, verify eligibility, then activate the partner discount on your account.",
      },
      {
        q: "How does the LTSZ integration work? Do I need to configure anything?",
        a: "No. We connect it during onboarding — after that, appointments booked on your website automatically appear in LTSZ.",
      },
      {
        q: "What happens after year 2?",
        a: "From year 3 you pay the regular Bespire price (monthly or annual, whichever you prefer). It's still better than using several separate tools.",
      },
      {
        q: "Does the discount apply to both monthly and annual billing?",
        a: "Yes, both. With annual billing you can combine it with the standard −20% annual discount.",
      },
      {
        q: "Can I cancel?",
        a: "Anytime, no long‑term commitment — it stays active until the end of the current billing cycle.",
      },
      {
        q: "How long is the trial?",
        a: "3 days free with full AI assistant access. No card required, cancel anytime.",
      },
    ],
  },
  finalCta: {
    heading: "Start free",
    description:
      "Launch Bespire free for 3 days with full AI assistant access — no card, cancel anytime. TSMT® discount can be activated during the trial.",
    ctaPrimary: "Start free",
    ctaSecondary: "Talk on the phone",
  },
};
